/**
 * @module Constants/validationErrors
 * */

/**
 * Строка со вставками вида {val}
 * @typedef {String} StringTemplate
 * */

/**
 * @constant {String} - Не уникальное значение
 * */
export const NOT_UNIQUE = 'Поле с таким значением уже зарегестрировано'

/**
 * @constant {String} - Обязательное поле
 * */
export const REQUIRED = 'Обязательное поле'

/**
 * @constant {String} - Неправильный email
 * */
export const EMAIL = 'Введите правильный E-mail'

/**
 * @constant {String} - Не привильный номер телефона
 * */
export const PHONE = 'Неправильно набранный номер'

/**
 * @constant {String} - Не верно заполненное поле
 * */
export const UNIVERSAL_INVALID_FIELD = 'Не верно заполненное поле'

/**
 * @constant {String} - Только кирилица и пробелы
 * */
export const CYRILLIC_AND_SPACE = 'Только кирилица и пробелы'

/**
 * @constant {String} - Только цифры
 * */
export const DIGIT = 'Только цифры'
/**
 * @constant {String} - Только цифры
 * */
export const TIME = 'Недопустимое значение для времени'

/**
 * @constant {StringTemplate} - Поле должно содержать не менее {min} символов
 * */
export const STRING_RANGE_MIN = 'Поле должно содержать не менее {min} символов'

/**
 * @constant {StringTemplate} - Поле должно содержать не более {max} символов
 * */
export const STRING_RANGE_MAX = 'Поле должно содержать не более {max} символов'

/**
 * @constant {StringTemplate} - Поле должно содержать от {min} до {max} символов
 * */
export const STRING_RANGE_MIN_MAX = 'Поле должно содержать от {min} до {max} символов'

/**
 * @constant {StringTemplate} - Поле должно содержать символов: {count}
 * */
export const STRING_RANGE_EXACT = 'Поле должно содержать символов: {count}'
/**
 * @constant {StringTemplate} - Должно быть не меньше {min}
 * */
export const NUMBER_RANGE_MIN = 'Должно быть не меньше {min}'

/**
 * @constant {StringTemplate} - Должно быть не больше {max}
 * */
export const NUMBER_RANGE_MAX = 'Должно быть не больше {max}'

/**
 * @constant {StringTemplate} - Должно быть от {min} до {max}
 * */
export const NUMBER_RANGE_MIN_MAX = 'Должно быть от {min} до {max}'

/**
 * @constant {StringTemplate} - Должно быть: {count}
 * */
export const NUMBER_RANGE_EXACT = 'Должно быть: {count}'

/**
 * @constant {StringTemplate} - Файл не должен превышать {max}MB
 * */
export const FILE_SIZE_MAX = 'Файл не должен превышать {max}MB'

/**
 * @constant {StringTemplate} - Не верное количеств слов. Ожидается: {wordsCount}
 * */
export const WORDS_COUNT = 'Не верное количеств слов. Ожидается: {wordsCount}'

/**
 * @constant {StringTemplate} - Доступные форматы: .pdf, .png, .jpg
 * */
export const FILE_FORMAT_TYPES = 'Доступные форматы: .pdf, .png, .jpg'

export default {
  NOT_UNIQUE,
  REQUIRED,
  EMAIL,
  PHONE,
  UNIVERSAL_INVALID_FIELD,
  CYRILLIC_AND_SPACE,
  DIGIT,
  RANGE_MIN: STRING_RANGE_MIN,
  RANGE_MAX: STRING_RANGE_MAX,
  RANGE_MIN_MAX: STRING_RANGE_MIN_MAX,
  RANGE_EXACT: STRING_RANGE_EXACT,
  FILE_SIZE_MAX,
  WORDS_COUNT,
  FILE_FORMAT_TYPES
}
